import React, { useEffect, useState } from 'react';
import styles from './DpTableMobileSection.module.scss';
import ToolTip from '../../ToolTip/ToolTip';
import RichText from '../../richtext';
import { countZero, getElementMaximumHeight } from '../../../utils/utils';
import SkeletonLoader from '../../SkeletonLoader/SkeletonLoader';

const DpTableMobileSection = ({
  productData, //each product's sb content
  mainContent, //whole content
  offerDataList, //offer response
  tabIndex,
  indexKey, //index of the product inside tab
  cardsLength //total no of prducts in the tab
}: any) => {
  const [productOfferData, setProductOfferData] = useState<any>();

  useEffect(() => {
    if (Object.keys(offerDataList)?.length > 0) {
      setProductOfferData(offerDataList?.[`${productData?.mobProductId}`]); //fetching offer response of specific product from the list
    }

    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener('load', findHeight);
    window?.addEventListener('resize', findHeight);

    return () => {
      window.removeEventListener('resize', findHeight);
      window.removeEventListener('load', findHeight);
    };
  }, [offerDataList]);

  const findHeight = () => {
    getElementMaximumHeight(`mobileSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`mobileDescSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`mobilePriceSection${tabIndex}`, cardsLength);
  };

  return (
    <>
      <div className={styles.mobileSection}>
        {productOfferData && Object.keys(productOfferData)?.length > 0 ? (
          <>
            {/* mobile title */}
            <div className={styles.mobileTitleSection} id={`mobileSection${tabIndex}${indexKey}`}>
              {productData?.mobTitle}
              <img src={mainContent?.fiveGIcon?.filename} alt='' width={24} height={24} />
            </div>
            {/* mobile description */}
            <div id={`mobileDescSection${tabIndex}${indexKey}`}>
              {productData?.mobDescription?.length > 0 &&
                (productData?.mobDescription || [])?.map((description: any) => {
                  return (
                    <div className={styles.mobileEntitlement}>
                      <RichText content={description?.text} />
                      <ToolTip content={description?.tooltipTxt} />
                    </div>
                  );
                })}
            </div>
            <hr />
            {/* mobile price section */}
            <div
              className={styles.mobilePriceContainer}
              id={`mobilePriceSection${tabIndex}${indexKey}`}
            >
              <div className={styles.mobilePriceSection}>
                {productOfferData?.derivedPrice?.[0]?.value && (
                  <img src={mainContent?.discountIcon?.filename} alt='' width={24} height={24} />
                )}
                <div className={styles.mobileDiscountedPrice}>
                  {productOfferData?.derivedPrice?.[0]?.value
                    ? countZero(productOfferData?.derivedPrice?.[0]?.value) //mobile discount price
                    : countZero(productOfferData?.prices?.[0]?.value)}
                  <span className={styles.month}>{mainContent?.contractLabel}</span>
                </div>
                {productOfferData?.derivedPrice?.[0]?.value && (
                  // mobile base price
                  <div className={styles.mobileBasePrice}>
                    {countZero(productOfferData?.prices?.[0]?.value)}
                  </div>
                )}
              </div>
              {/* discount description */}
              <div className={styles.mobilePriceDescription}>
                {productData?.mobDiscountText}
                <ToolTip content={productData?.mobDiscountTooltip} />
              </div>
            </div>
          </>
        ) : (
          <SkeletonLoader count={5} />
        )}
      </div>
    </>
  );
};

export default DpTableMobileSection;
